import { DimensionValueSet } from "@/lib/dimensions";
import { getCacheKeyForDimensionValueSet } from "@/lib/dimensions/helpers";

export class TileLoadFailureTracker {
  private failedKeys = new Set<string>();

  markFailed(dimensionValues: DimensionValueSet) {
    this.failedKeys.add(getCacheKeyForDimensionValueSet(dimensionValues));
  }

  hasLoadError(dimensionValues: DimensionValueSet) {
    return this.failedKeys.has(getCacheKeyForDimensionValueSet(dimensionValues));
  }

  hasPartialLoadErrors() {
    return this.failedKeys.size > 0;
  }

  clear() {
    this.failedKeys.clear();
  }
}
